import { render, staticRenderFns } from "./ALSort.vue?vue&type=template&id=21b49daa&scoped=true"
import script from "./ALSort.vue?vue&type=script&lang=js"
export * from "./ALSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b49daa",
  null
  
)

export default component.exports